<div fxLayout="column" fxLayoutAlign="center center">
  <div class="next-steps">
    <h1>Discipleship Path <strong>BIBLE STUDY</strong> Next Steps</h1>
    <p>With respect to <strong>BIBLE STUDY</strong>, below are considerations to enhance your spiritual walk in Christ.
      Jesus answered, “It is
      written: 'Man shall not live on bread alone, but on every word that comes from the mouth of God.' [Matt 4:4]</p>
  </div>
  <hr class="divider" />
  <div class="exploring-christ">
    <h2>Exploring Christ</h2>
    <ul>
      <li>Choose a <strong>BIBLE</strong> that you can read easily and understand. A 'study Bible' is a good idea, as
        there is helpful
        information throughout. The best <strong>BIBLE</strong> is the one you read!</li>
      <li>Here is a good guide to translations: <a
          href="https://asymphonyofpraise.com/blog/ultimate-guide-to-bible-translations" target="_blank">Ultimate Guide
          To Bible Translations</a>
      </li>
      <li>Begin by reading The Gospels [Matthew, Mark, Luke & John] John is an excellent 1st book to read.</li>
      <li>Consider a <strong>BIBLE</strong> app for your phone - <a href="https://bible.com"
          target="_blank">YouVersion</a> is an excellent one. This has <strong>BIBLE</strong> reading guides for
        beginners, as well as topical <strong>BIBLE</strong> studies</li>
    </ul>
  </div>
  <div class="growing-in-christ">
    <h2>Growing In Christ</h2>
    <ul>
      <li>Read the <strong>BIBLE</strong> every day. Remember: you don't need to fully understand everything right away.
        The important thing is that you are feasting on God's Word!</li>
      <li>As you read, pray about what you
        are reading, ask God to help you
        understand & how to apply to your life.
      </li>
      <li>Begin to use a <strong>BIBLE STUDY</strong> guide, [e.g. on the YouVersion app] or a book of your choosing, to
        help you discover meaning in what you are reading. Ask your Pastor or a mentor for their recommendation.
      </li>
      <li>Consider joining a small group <strong>BIBLE STUDY</strong> to begin to discuss Scripture with others. Ask
        questions!</li>

      <li> As you read and study God's word regularly, you will discover that it will begin to be the authority in your
        life.</li>

      <li><a href="https://biblia.com/bible/esv/2-timothy/3/16-17" target="_blank">2 Timothy 3:16-17</a></li>
    </ul>
  </div>
  <div class="close-to-christ">
    <h2>Close To Christ</h2>
    <ul>
      <li> Continue to study the <strong>BIBLE</strong> daily. A great way to study the Scripture is inductive study.
        Here is a website that explains this: <a href="https://www.precept.org" target="_blank">Precept</a></li>
      <li> Pray and reflect on what you are reading, let it shape the way you see everything in your life. Never be
        afraid to ask questions!</li>
      <li> Consider a “read through the Bible” reading plan, which guides you through the entire <strong>BIBLE</strong>
        in a certain period of time - 6 months, 1 year, etc.</li>
      <li> Continue <strong>BIBLE STUDY</strong> w/others.</li>
      <li> Begin to memorize verses</li>
      <li> The God's Word is becoming the authority in all that you do, guiding your decisions.</li>
      <li><a href="https://biblia.com/bible/esv/joshua/1/8" target="_blank">Joshua 1:8</a></li>
    </ul>
  </div>
  <div class="christ-centered">
    <h2>Christ-Centered</h2>
    <ul>
      <li> The <strong>BIBLE</strong>, the Word of God, is now the guiding authority in your life as you read and
        reflect on it every day.</li>
      <li> Continue to pray as you read, ask God to show you what He wants you to know</li>
      <li> Apply what you read & learn for everyday life, use Biblical wisdom in all you do & say.</li>
      <li> Continue to study with others, consider how you can share your knowledge of the <strong>BIBLE</strong></li>
      <li> Continue to memorize scripture</li>
      <li> Remember - even though you have read a book, chapter, passage before, God can always reveal something new to
        you.</li>
      <li><a href="https://biblia.com/bible/esv/psalm/19/5-7" target="_blank">Psalm 119:5-7</a></li>
    </ul>
  </div>
</div>